import { useNavigate, useParams } from 'react-router-dom';
import { useTable } from '../../hooks/useTableManagement';
import { useFlicButtonManagement } from '../../hooks/useFlicButtonManagement';
import { ButtonManagement } from '../../components/admin/ButtonManagement';
import { Button } from '../../components/ui/Button';
import './ButtonManagementPage.css';

export function ButtonManagementPage() {
  const navigate = useNavigate();
  const { tableId } = useParams<{ tableId: string }>();
  
  const { data: table, isLoading: isLoadingTable } = useTable(tableId || '');
  const {
    buttons,
    isLoading: isLoadingButtons,
    assignButton,
    removeButton,
    isAssigning,
    isRemoving,
  } = useFlicButtonManagement(tableId || '');

  const handleAssign = async (serialNumber: string, buttonType: 'sideA' | 'sideB') => {
    await assignButton({ serialNumber, buttonType });
  };

  const handleRemove = async (buttonId: string) => {
    if (!confirm('Tem certeza que deseja remover este botão?')) {
      return;
    }
    await removeButton(buttonId);
  };

  if (isLoadingTable || isLoadingButtons) {
    return (
      <div className="button-management-page">
        <div className="button-management-page__loading">Carregando...</div>
      </div>
    );
  }

  if (!table) {
    return (
      <div className="button-management-page">
        <div className="button-management-page__error">Mesa não encontrada</div>
      </div>
    );
  }

  return (
    <div className="button-management-page">
      <div className="button-management-page__header">
        <div>
          <Button variant="secondary" onClick={() => navigate('/admin/tables')}>
            ← Voltar
          </Button>
          <h1 className="button-management-page__title">
            Gerenciar Botões - {table.name}
          </h1>
          {table.location && (
            <p className="button-management-page__subtitle">📍 {table.location}</p>
          )}
        </div>
      </div>

      <ButtonManagement
        buttons={buttons}
        onAssign={handleAssign}
        onRemove={handleRemove}
        isAssigning={isAssigning}
        isRemoving={isRemoving}
      />
    </div>
  );
}
